import { BRIEF_PATH } from "./format";

export const BRIEF_PAGE_SIZE = 12;

export function archivePath(page = 1) {
    return page === 1 ? BRIEF_PATH : `${BRIEF_PATH}?page=${page}`;
}

export function archivePage(value: string | string[] | undefined, count: number): number | undefined {
    if (value === undefined) return 1;
    if (typeof value !== "string" || !/^[1-9]\d*$/.test(value)) return undefined;
    const page = Number(value);
    return Number.isSafeInteger(page) && page <= Math.max(1, Math.ceil(count / BRIEF_PAGE_SIZE)) ? page : undefined;
}
